import { Component, computed, effect, inject, input } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { CardComponent } from '../../../kit/card/card.component';
import { SocialBillingStatusWidgetStore } from './social-billing-status-widget.store';
import { CheckOrCrossComponent } from '../../../kit/check-or-cross/check-or-cross.component';
import { FormatNumberPipe } from '../../../../modules/shared/pipes/format-number.pipe';

@Component({
    selector: 'app-social-billing-status-widget',
    templateUrl: './social-billing-status-widget.component.html',
    styleUrl: './social-billing-status-widget.component.scss',
    imports: [
        TranslatePipe,
        CardComponent,
        CheckOrCrossComponent,
        FormatNumberPipe,
    ],
    providers: [
        SocialBillingStatusWidgetStore,
    ],
})
export class SocialBillingStatusWidgetComponent {

    protected readonly store = inject(SocialBillingStatusWidgetStore);

    public folderId = input.required<number, string | number>({
        transform: (it) => Number(it),
    });
    public showHeader = input(true);

    protected readonly prefix = 'socialBilling.billingStatus.';

    protected readonly status = computed(() => this.store.data.getSocialBillingDocumentStatus());
    protected readonly allPaid = computed(() => !this.status()?.hasUnpaidBilling);
    protected readonly remainingPayment = computed(() => this.status()?.remainingPayment || 0);
    protected readonly overpayment = computed(() => this.status()?.overpayment || 0);

    constructor() {
        effect(() => {
            const folderId = this.folderId();
            if (!folderId) return;

            void this.reload();
        });

        this.store.onSuccess(
            () => this.reload(),
            'createSocialPartialBilling',
            'createSocialNewBilling',
            'deleteSocialBillingDocument',
            'createSocialPayment',
            'updateSocialPayment',
            'deleteSocialPayment',
            'paySocialPaymentFromFinancialDeposit',
            'addSocialPaymentPreviousBillingBalance',
        );
    }

    public async reload(): Promise<void> {
        const folderId = this.folderId();
        if (!folderId) return;

        await this.store.api.getSocialBillingDocumentStatus(
            { id: folderId },
            `
                remainingPayment
                overpayment
                hasUnpaidBilling
            `,
        );
    }

}
